import { ErrorType } from 'shared/enums/ErrorType';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.errors.NetworkError';

export class NetworkError extends Error {
  response: Error;

  constructor(response) {
    super(response);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NetworkError);
    }

    const message =
      response?.data?.localized_messages?.[0] ||
      response?.data?.messages?.[0] ||
      t(`${TP}.message`, 'Oops, something went wrong.');

    this.name = ErrorType.NetworkError;
    this.message = message;
    this.response = {
      ...response,
      name: ErrorType.NetworkError,
      message,
    };
  }
}
